import MenuAction from 'components/MenuAction';
import { useSelector } from 'react-redux';
import React, { useState } from 'react';

const useReviewer = (props) => {
    const { setOpenPopup, setSelectedRow, getReviewerList } = props;
    const reviewer = useSelector((state) => state.reviewer);
    const [isResetPassword, setIsResetPassword] = useState(false);
    const [sort, setSort] = useState('updateDtm');
    const [isDesc, setIsDesc] = useState(true);

    const getMenuActions = (row) => {
        return [
            {
                text: 'Edit',
                action: () => {
                    setOpenPopup(true);
                    setSelectedRow(row);
                },
                disableConfirm: true,
            },
            {
                text: 'Reset Password',
                action: async () => {
                    setIsResetPassword(true);
                    setSelectedRow(row);
                },
            },
        ];
    };

    const columns = [
        {
            field: 'action',
            sortable: false,
            headerName: 'Action',
            width: 80,
            disableItemSort: true,
            renderCell: (params) => {
                return <MenuAction actions={getMenuActions(params.row)} row={params.row} />;
            },
        },
        {
            field: 'email', headerName: 'Email', width: 200,
            onSort: (key, isDesc) => {
                setSort(key);
                setIsDesc(isDesc);
                getReviewerList(null, null, key, isDesc);
            },
        },
        {
            field: 'title', headerName: 'Title', width: 100,
            onSort: (key, isDesc) => {
                setSort(key);
                setIsDesc(isDesc);
                getReviewerList(null, null, key, isDesc);
            },
        },
        {
            field: 'surname', headerName: 'Surname', width: 150,
            onSort: (key, isDesc) => {
                setSort(key);
                setIsDesc(isDesc);
                getReviewerList(null, null, key, isDesc);
            },
        },
        {
            field: 'firstName', headerName: 'First Name', width: 150,
            onSort: (key, isDesc) => {
                setSort(key);
                setIsDesc(isDesc);
                getReviewerList(null, null, key, isDesc);
            },
        },
        {
            field: 'gender', headerName: 'Gender', width: 100,
            renderCell: (params) => {
                const data = { F: 'Female', M: 'Male' };
                return data[params.row.gender]
            },
            onSort: (key, isDesc) => {
                setSort(key);
                setIsDesc(isDesc);
                getReviewerList(null, null, key, isDesc);
            },
        },
        { field: 'department', headerName: 'Department', width: 140,
            onSort: (key, isDesc) => {
                setSort(key);
                setIsDesc(isDesc);
                getReviewerList(null, null, key, isDesc);
            },
        },
        { field: 'post', headerName: 'Post', width: 100,
            onSort: (key, isDesc) => {
                setSort(key);
                setIsDesc(isDesc);
                getReviewerList(null, null, key, isDesc);
            },
        },
    ];

    return {
        columns,
        rows: reviewer.reviewerList,
        total: reviewer.reviewerTotal,
        setIsResetPassword,
        isResetPassword,
        sort,
        isDesc,
    };
};

export default useReviewer;
